import cx from 'classnames'
import { ReactComponent as Icon } from 'assets/icons/articleMention.svg'
import Styles from './MentionIcon.module.scss'

export function MentionIcon({ className = '' }: { className?: string }) {
  return <Icon className={cx(className, Styles.icon)} />
}
